import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import shower from "../../assets/shower.png";
import tv from "../../assets/tv.png";
import color from "../../assets/color.png";
import nor from "../../assets/nor.png";
import mfk from "../../assets/mfk.png";
import { Carousel } from "antd";
import Product from "../Product";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesPro } from "../../redux/ecommerce/categoriesProductsSlice";
import { fetchProducts } from "../../redux/ecommerce/productsSlice";
import { Tabs, Card, Row, Col } from "antd";
import order from "../../assets/myOrders/OrderEmpty.png";

const { TabPane } = Tabs;

const Explore = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();

  const { categoriesProducts, status, error } = useSelector(
    (state) => state.categoriesProducts
  );

  const { products, statusPro, errorPro } = useSelector(
    (state) => state.products
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCategoriesPro());
    }
  }, [status, dispatch]);

  useEffect(() => {
    if (categoriesProducts.length > 0 && status === "succeeded") {
      categoriesProducts.forEach((category) => {
        dispatch(fetchProducts({ status: "recent", category_id: category.id }));
      });
    }
  }, [categoriesProducts, status, dispatch]);

  const onChange = (key) => {
    console.log(key);
  };

  const renderProducts = (categoryId) => {
    if (statusPro === "loading") {
      return (
        <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
          Loading products...
        </p>
      );
    }

    const categoryProducts = products.filter(
      (product) => product.eco_category_id === categoryId
    );

    if (categoryProducts.length === 0) {
      return (
        <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
          No products available in this category.
        </p>
      );
    }

    const chunkProducts = (products, chunkSize) => {
      const result = [];
      for (let i = 0; i < products.length; i += chunkSize) {
        result.push(products.slice(i, i + chunkSize));
      }
      return result;
    };

    const productChunks = chunkProducts(categoryProducts, 3);

    return (
      <Carousel arrows={productChunks.length > 1} infinite={false}>
        {productChunks.map((chunk, index) => (
          <div key={index}>
            <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-6 px-20 max-lg:px-8 mt-5">
              {chunk.map((product, idx) => (
                <Product
                  key={idx}
                  id={product.id}
                  color_id={product.colors[0]?.id || null}
                  count={1}
                  image={`https://ecommerce.samoolah.com${product.image}`}
                  name={language === "en" ? product.name_en : product.name_ar}
                  price={product.price}
                  link={product.id}
                />
              ))}
            </div>
          </div>
        ))}
      </Carousel>
    );
  };

  return (
    <div className="my-20 px-20 max-lg:px-5 relative Explore">
      <div className="flex justify-between items-center mb-5">
        <h3 className="text-[#14294F] text-2xl font-semibold mb-0">
          {t("Explore Our Products")}
        </h3>
        <Link
          to="/products"
          className={`text-[#FE9B71] rounded-full border-4 border-[#FE9B71] w-[200px] h-[50px] ${language == "ar" && "max-lg:w-[150px]"} text-xl flex items-center justify-center font-semibold`}
        >
          {language == "en" ? (
            <>
              {t("Shop Now")}
              <RightOutlined className="ml-8 max-lg:ml-2 font-bold" />
            </>
          ) : (
            <>
              {t("Shop Now")}
              <LeftOutlined className="mr-8 max-lg:mr-2 font-bold" />
            </>
          )}
        </Link>
      </div>
      <div className="relative Explore">
        {/* {status === "loading" || statusPro === "loading" ? (
          <p className="text-center text-xl text-[#FE9B71]">Loading...</p>
        ) : (
          <Tabs defaultActiveKey="0" className="mt-3" dir="ltr">
            {categoriesProducts.map((category, index) => (
              <TabPane
                tab={
                  <div className="bg-[#FCFBFA] p-5 w-[100px] h-[100px] rounded-xl act flex items-center">
                    <img
                      src={`https://ecommerce.samoolah.com/${category.image}`}
                      alt={category.name}
                      className="w-[50px] mx-auto"
                    />
                  </div>
                }
                key={index}
              >
                {renderProducts(category.id)}
              </TabPane>
            ))}
          </Tabs>
        )} */}
        <div>
          <div className="text-center">
            <img
              src={order}
              className=" max-lg:w-[230px] lg:w-[300px] mx-auto mt-14 max-lg:mt-10"
            />
            <h2 className="text-[#283D63] text-2xl sm:text-3xl md:text-4xl font-semibold leading-relaxed">
              {t("Coming Soon")}
            </h2>
            <p className="text-[#737E91] mt-4">{t("stay tuned")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Explore;
